import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Background } from './style';

const AuthLayout = (WrapperContent) => {
    
    const WrappedComponent = () => {

        const banner = [
            // require('../../static/img/login/banner_1.jpg'),
            // require('../../static/img/login/banner_2.jpg'),
            // require('../../static/img/login/banner_3.jpg'),
            require('../../static/img/login/banner_4.png'),
        ]; 

        const [randomImage, setRandomImage] = useState('');
            
        const generateRandomImage = () => {
            const randomIndex = Math.floor(Math.random() * banner.length);
            const randomImageUrl = banner[randomIndex];
            setRandomImage(randomImageUrl);
        };
        
        useEffect(() => {
            generateRandomImage();
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);

        return(
            <>
                {randomImage ? (
                    <Background  imageurl={randomImage} >
                        <WrapperContent />
                    </Background>
                ) : (
                    <>
                        <WrapperContent />
                    </>
                )}
            </>            
            
        );
    }

    return WrappedComponent;
};

// PropTypes validation for AuthLayout component
AuthLayout.propTypes = {
    WrapperContent: PropTypes.elementType.isRequired, // Ensure WrapperContent is a valid React element
};

export default AuthLayout;